import { render, staticRenderFns } from "./ContactsPad.vue?vue&type=template&id=8e9e2586&scoped=true"
import script from "./ContactsPad.vue?vue&type=script&lang=js"
export * from "./ContactsPad.vue?vue&type=script&lang=js"
import style0 from "./ContactsPad.vue?vue&type=style&index=0&id=8e9e2586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9e2586",
  null
  
)

export default component.exports